import NextLink from "next/link";
import css from "./Header.module.css";

export interface HeaderProps {}

const BASE_CLASS = "f-OrganismHeader";

export const Header = ({}: HeaderProps) => (
  <header className={css[BASE_CLASS]}>
    <div className={css[`${BASE_CLASS}-logo`]}>
      <NextLink href="/">[forCode]</NextLink>
    </div>
  </header>
);
